<ng-template #fontSizeMenu>
  <div class="document-editor-menu__select-wrapper">
    <select class="document-editor-menu__select" (change)="onFontSizeSelect($event)">
      <option value="">Size</option>
      <option *ngFor="let size of fontSizes" [value]="size.value">{{ size.label }}</option>
    </select>
  </div>
  <!-- <div class="NgxEditor__MenuItem NgxEditor__MenuItem--Icon" role="button"
    title="Increase font size" (mousedown)="onFontSizeChange($event, 1)">
    <span class="NgxEditor__MenuItem--IconContainer">A+</span>
  </div>
  <div class="NgxEditor__MenuItem NgxEditor__MenuItem--Icon" role="button"
    title="Decrease font size" (mousedown)="onFontSizeChange($event, -1)">
    <span class="NgxEditor__MenuItem--IconContainer">A-</span>
  </div> -->
</ng-template>

<ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [customMenuRef]="fontSizeMenu"> </ngx-editor-menu>
